"use strict";

module.exports = {
  DefaultFreeTextIndex: -1
};